import AbortService from "@rmp/core/services/abortService";
import { AuthController } from "@rmp/core/api/auth";
import SecurityService from "@rmp/core/services/auth/securityService";

export const selectProfile = async (profileId: string, payload?: any) => {
	const abortService = new AbortService();
	abortService.initialize();
	
	const authController = new AuthController(abortService);
	const securityService = new SecurityService();
	
	try {
		await authController.signInWithProfile({
			profileId,
			signedPayload: payload
		}, {
			withCredentials: true,
			skipAuthRefresh: true
		});
		
		await securityService.reloadSession();
	} catch (error) {
		console.error(error);
		throw error;
	}
};
